import { render, staticRenderFns } from "./LsDashboards.vue?vue&type=template&id=13b1b635&scoped=true&"
import script from "./LsDashboards.vue?vue&type=script&lang=js&"
export * from "./LsDashboards.vue?vue&type=script&lang=js&"
import style0 from "./LsDashboards.vue?vue&type=style&index=0&id=13b1b635&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1b635",
  null
  
)

export default component.exports